import { render } from "./DeviceLogs.vue?vue&type=template&id=bb71557e&scoped=true"
import script from "./DeviceLogs.vue?vue&type=script&lang=js"
export * from "./DeviceLogs.vue?vue&type=script&lang=js"

import "./DeviceLogs.vue?vue&type=style&index=0&id=bb71557e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb71557e"]])

export default __exports__